import { render, staticRenderFns } from "./ManageSeminar.vue?vue&type=template&id=27ff3f32&scoped=true&"
import script from "./ManageSeminar.vue?vue&type=script&lang=js&"
export * from "./ManageSeminar.vue?vue&type=script&lang=js&"
import style0 from "./ManageSeminar.vue?vue&type=style&index=0&id=27ff3f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff3f32",
  null
  
)

export default component.exports